import React, { Component } from 'react'
import ImageFour from '../../Images/Mushroom/tms-arge-mushroom4.webp'

class Mushroom extends Component {
    render() {
        return (
            <div id='mushroom'>
                <h3 className="w-100 text-center mb-4">MUSHROOM NETWORKS</h3>
                <div >
                    <img src={ImageFour} alt="tms-arge-mushroom-1 w-25" title="tms-arge-mushroom-1" />
                </div>
                <div className='mushroom-body'>
                    Unternehmen Mushroom Network, das wir in der Türkei vertreten;<br />
                    <a href="https://www.mushroomnetworks.com/" alt="mushroom-tms" target="_blank" rel="noopener noreferrer">
                        https://www.mushroomnetworks.com/
                    </a>
                    {/* <br />
                    <a href="mailto:atillakarabulut@tmstechnic.com" alt="mushroom-tms-mail" >
                        atillakarabulut@tmstechnic.com
                    </a>
                    <br />
                    <a href="mailto:alikarabulut@tmstechnic.com" alt="mushroom-tms-mail-2" >
                        alikarabulut@tmstechnic.com
                    </a> */}
                    <br />
                    <a href="mailto:info@tmstechnic.com" alt="mushroom-tms-mail-2" >
                        info@tmstechnic.com
                    </a>

                </div>
            </div>
        )
    }
}
export default Mushroom;